/* unplugin-vue-components disabled */import script from "./ImageDall.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageDall.vue?vue&type=script&setup=true&lang=js"

import "./ImageDall.vue?vue&type=style&index=0&id=b11f1e5c&lang=stylus"

const __exports__ = script;

export default __exports__